import { Outlet } from "react-router-dom";

import ProtectedRoute from "../../components/hoc/ProtectedRoute";

const Template = () => {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
};

export default Template;
